import { SyntheticEvent, VFC } from 'react'
import { DEFAULT_IMAGE } from 'src/assets/images'
import { truewhite } from 'src/styles/colors'
import { flexCenter } from 'src/styles/mixins'
import styled, { css } from 'styled-components'

export { UserIcon }
type UserIconProps = {
  src: string | undefined | null
  alt?: string
  size: string
  withBorder?: boolean
  borderColor?: string
  className?: string
  hideWithBlur?: boolean
  onClick?: () => void
}
const handleImageError = (e: SyntheticEvent<HTMLImageElement>) => {
  const img = e.currentTarget
  if (img.src !== DEFAULT_IMAGE) img.src = DEFAULT_IMAGE
}

const UserIconComponent: VFC<UserIconProps> = ({
  src,
  withBorder,
  borderColor,
  className,
  ...props
}) =>
  withBorder || borderColor ? (
    <Border className={className} size={props.size} borderColor={borderColor}>
      <Icon {...props} src={src || DEFAULT_IMAGE} onError={handleImageError} />
    </Border>
  ) : (
    <Icon
      className={className}
      {...props}
      src={src || DEFAULT_IMAGE}
      onError={handleImageError}
    />
  )

const UserIcon = styled(UserIconComponent)``

const Icon = styled.img<{
  size?: string
  hideWithBlur?: boolean
  onClick?: () => void
}>`
  border-radius: 50%;
  object-fit: cover;
  ${({ size }) =>
    size &&
    css`
      width: ${size};
      height: ${size};
    `}
  ${({ hideWithBlur }) =>
    hideWithBlur &&
    css`
      filter: blur(2.5px);
    `}
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}
`

const Border = styled.div<{ size?: string; borderColor?: string }>`
  ${flexCenter};
  border-radius: 50%;
  background-color: ${({ borderColor = truewhite }) => borderColor};
  ${({ size }) =>
    size &&
    css`
      width: ${size};
      height: ${size};
    `}

  ${Icon} {
    width: 80%;
    height: 80%;
  }
`
